// extracted by mini-css-extract-plugin
export default {"container":"Home_container__5xSil","light":"Home_light__OO+1s","dark":"Home_dark__vf07M"};